import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
export default function NavBar() {
  return (
    <div className="navBar Caveat">
      <ul>
        <Link to="/#home">
          <li className="navElement">
            <span className="navText">HOME</span>
          </li>
        </Link>
        <Link to={"/#about"}>
          <li className="navElement">
            <span className="navText">ABOUT</span>
          </li>
        </Link>
        <Link to={"/projects"}>
          <li className="navElement">
            <span className="navText">PROJECTS</span>
          </li>
        </Link>
        <Link to={"/#connect"}>
          <li className="navElement">
            <span className="navText">CONNECT</span>
          </li>
        </Link>
        <Link to={"/resume"}>
          <li className="navElement">
            <span className="navText">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9h-1V14H1V9.9H.5zM8 10.5L4 6.5h2V1h4v5.5h2L8 10.5z" />
              </svg>
              RESUME
            </span>
          </li>
        </Link>
      </ul>
    </div>
  );
}
